import { Component, OnInit } from '@angular/core';
import { topics } from './topics';

declare var gtag: (...args: any[]) => void;

@Component({
    selector: 'app-onibus',
    templateUrl: './onibus.component.html',
    styleUrls: ['./onibus.component.scss']
})
export class OnibusComponent implements OnInit {
    topics = [];
    selectedTopicIndex = -1;

    constructor() { }

    setSelectedTopic(index) {
        if (this.selectedTopicIndex === index) {
            this.selectedTopicIndex = -1;
        }
        else {
            this.selectedTopicIndex = index;
        }
    }

    // Dispara a conversão do Google Ads e só então navega — como a
    // navegação acontece na mesma aba, o clique é interceptado
    // (preventDefault) e o redirect real só acontece no event_callback
    // do gtag (ou em até 2s via event_timeout, se o disparo falhar).
    verificarMeuProblemaClick(event: Event) {
        event.preventDefault();
        const url = 'https://helppassengers.com.br/contato';
        gtag('event', 'conversion', {
            'send_to': 'AW-10808804687/WxHDCNKH6uccEM-KhaIo',
            'value': 1.0,
            'currency': 'BRL',
            'event_callback': function () { document.location.href = url; },
            'event_timeout': 2000
        });
    }

    ngOnInit() {
        this.topics = topics;
    }
}
